import type { CollectionSummary } from './api-client'
import { chooseReadingSource } from './local-copy'
import type { LocalLibraryView } from './reader-session'

/**
 * 合併模式的集合格按下去要做什麼。與 openCollectionReader 同一條可讀性規則，但在進閱讀器
 * 之前做：任一成員既不能本機讀也未備份完成，就擋在書庫並點名那一話，不讓人進閱讀器才失敗。
 */
export type CollectionOpenTarget =
  | { kind: 'read'; path: string }
  | { kind: 'blocked'; message: string }

export const collectionReadPath = (collectionId: string) => `/read/collection/${encodeURIComponent(collectionId)}`

export function collectionOpenTarget(collection: CollectionSummary, local: LocalLibraryView | undefined): CollectionOpenTarget {
  for (const [index, member] of collection.members.entries()) {
    const choice = local ? chooseReadingSource({ id: member.comicId, pageCount: member.pageCount }, local.comics, local.libraries, local.isAuthorized) : { source: 'cloud' as const }
    if (choice.source === 'local' || member.syncState === 'ready') continue
    const held = local?.comics.some(comic => comic.cloudComicId === member.comicId)
    return {
      kind: 'blocked',
      message: held
        ? `第 ${index + 1} 話《${member.title}》的來源尚未授權或索引未完成，雲端也還沒備份完成，因此無法開啟這本合併冊。`
        : `第 ${index + 1} 話《${member.title}》這台裝置沒有它的檔案，雲端也還沒備份完成。在持有檔案的裝置備份完成後才能讀這本合併冊。`,
    }
  }
  return { kind: 'read', path: collectionReadPath(collection.id) }
}
